import { type InferType, object, ref, string } from "yup";
import { isUSA } from "../../../../../common/utils";
import { AddressInputSchemaGenerator } from "../../../../SharedAddressInput/constants";
import { getNameFromCountry } from "../../../mappers";

export enum AccountDetailsInputFields {
  AccountName = "accountName",
  Iban = "iban",
  ConfirmIban = "confirmIban",
  AdditionalInstructions = "additionalInstructions",
  AddressCountry = "country",
  AddressZip = "zip",
  AddressProvince = "province",
  AddressState = "state",
  AddressCity = "city",
  AddressStreetLine1 = "streetLine1",
  AddressStreetLine2 = "streetLine2",
}

const ibanTransform = (v: string | undefined) => v?.replace(/\s/g, "").toUpperCase();

export const ADDITIONAL_INSTRUCTIONS_MAX_LENGTH = 140;

export const SepaAccountDetailsInputSchema = object()
  .shape({
    [AccountDetailsInputFields.AccountName]: string()
      .required("Required field")
      .max(140, "Must be 140 characters or less")
      .matches(/\S/, "Account name cannot be just spaces."),
    [AccountDetailsInputFields.Iban]: string()
      .required("Required field")
      .transform(ibanTransform)
      .matches(
        /^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/,
        "IBAN must be 15–34 characters in the format: 2 letters, 2 digits, then alphanumeric",
      ),
    [AccountDetailsInputFields.ConfirmIban]: string()
      .required("Required field")
      .transform(ibanTransform)
      .oneOf([ref(AccountDetailsInputFields.Iban)], "Must match IBAN"),
    [AccountDetailsInputFields.AdditionalInstructions]: string().max(
      ADDITIONAL_INSTRUCTIONS_MAX_LENGTH,
      `Must be ${ADDITIONAL_INSTRUCTIONS_MAX_LENGTH} characters or less`,
    ),
  })
  .concat(
    AddressInputSchemaGenerator({
      testIsUSA: (country) => isUSA(getNameFromCountry(country)),
      zipRequiredForNonUS: false,
    }),
  );

export type SepaAccountDetailsInputType = InferType<typeof SepaAccountDetailsInputSchema>;
